import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"


const api = new APIClient();

// Get List
export const getEmailCampaigns = () => api.get(url.GET_EMAIL_CAMPAIGN, {});
export const getDetailEmailCampaign = (id: string) => api.get(`${url.GET_EMAIL_CAMPAIGN}/${id}`, {});
export const getEmailCampaignContacts = (id: string) => api.get(`${url.GET_EMAIL_CAMPAIGN}/${id}/contacts`, {});
export const deleteEmailCampaign = (id: string) => api.delete(`${url.GET_EMAIL_CAMPAIGN}/${id}`, {});
export const duplicateEmailCampaign = (id: string) => api.create(`${url.GET_EMAIL_CAMPAIGN}/${id}/duplicate`, {});
export const getQuestionAnswer = () => api.get(`${url.GET_Question_Answer}`, {});
export const updateStatusEmailCampaign = (id: string, payload?: any) => api.put(`${url.UPDATE_EMAIL_CAMPAIGN}/${id}/status`, payload);
export const updateEmailTemplate = (id: string, payload?: any) => api.put(`${url.UPDATE_EMAIL_CAMPAIGN}/${id}/email-template`, payload);
export const saveEmailCampaignContact = (id: string, payload?: any) => api.create(`${url.UPDATE_EMAIL_CAMPAIGN}/${id}/save-contacts`, payload);
export const updateEmailCampaignContact = (id: string) => api.create(`${url.UPDATE_EMAIL_CAMPAIGN}/${id}/update-contacts`, {});
export const updateEmailCampaign = (id: string, payload?: any) => api.put(`${url.UPDATE_EMAIL_CAMPAIGN}/${id}`, payload);
export const generateEmailTemplate = (payload: any): any => api.create(url.GENERATE_EMAIL_TEMPLATE, payload)
export const SendEmailMarketing = (payload: any) => api.create(url.SEND_EMAIL, payload);
export const SendCampaignMarketing = (payload: any) => api.create(url.SEND_CAMPAIGN_MARKETING, payload);

export const getCampaignResponse = (payload: any): Promise<any> => {
    return api.create(url.CAMPAIGN_AGENT, payload);
}

export const getCampaignConversations = (campaignId: string): Promise<any> => {
    return api.get(`${url.CAMPAIGN_CONVERSATIONS}/${campaignId}`, {});
    
}